import React from 'react';

const sectionStyle = 'mt-6 first:mt-0';

// Stable key for content blocks: position + type + first 20 chars of content
const blockKey = (block, i) => {
  const seed = block.text || (block.items && block.items[0]) || '';
  return `${i}-${block.type}-${seed.slice(0, 20)}`;
};

const ContentRenderer = ({ content }) => {
  return (
    <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed" data-testid="article-body">
      {content.map((block, i) => {
        const key = blockKey(block, i);

        if (block.type === 'p') {
          return (
            <p key={key} className={`${sectionStyle} text-base sm:text-[17px] text-gray-700`}>
              {block.text}
            </p>
          );
        }
        if (block.type === 'h2') {
          return (
            <h2 key={key} className="mt-10 mb-3 text-2xl sm:text-3xl font-semibold text-gray-900 tracking-tight">
              {block.text}
            </h2>
          );
        }
        if (block.type === 'h3') {
          return (
            <h3 key={key} className="mt-8 mb-2 text-xl font-semibold text-gray-900">
              {block.text}
            </h3>
          );
        }
        if (block.type === 'ul') {
          return (
            <ul key={key} className="mt-4 space-y-2 list-disc pl-6 text-gray-700">
              {block.items.map((item) => (
                <li key={item} className="leading-relaxed">{item}</li>
              ))}
            </ul>
          );
        }
        if (block.type === 'ol') {
          return (
            <ol key={key} className="mt-4 space-y-2 list-decimal pl-6 text-gray-700">
              {block.items.map((item) => (
                <li key={item} className="leading-relaxed">{item}</li>
              ))}
            </ol>
          );
        }
        if (block.type === 'callout') {
          return (
            <div key={key} className="mt-6 p-5 rounded-xl bg-gradient-to-r from-blue-50 to-teal-50 border-l-4 border-blue-500 text-gray-800">
              {block.text}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default ContentRenderer;
